// import '../vendors/custom-inputs';
jQuery( document ).ready( function() {
	let categoryTerm;
	// const categotyselect = jQuery( '#dropdown-category-select' ).CustomSelect();
	// typeTerm = jQuery( '#dropdown-pre-owned-select' ).data( 'value' ) ?? '';
	function updateThePermalink() {
		if ( history.pushState ) {
			const oldUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;
			let baseUrl = oldUrl;
			const queryParams = [];
			if ( categoryTerm !== undefined && categoryTerm !== '' ) {
				queryParams.push( `category=${ encodeURIComponent( categoryTerm ) }` );
			}
			// Construct the query string
			if ( queryParams.length > 0 ) {
				baseUrl += '?' + queryParams.join( '&' );
			}
			window.history.pushState( { path: baseUrl }, '', baseUrl );
		}
	}
	jQuery( '.select-blog-dropdown__checkbox' ).on( 'click', function() {
		categoryTerm = jQuery( this ).data( 'value' );
		sendAjaxRequest();
		updateThePermalink();
	} );
	function sendAjaxRequest() {
		console.log( categoryTerm );
		jQuery( '.lds-roller' ).show();
		jQuery.ajax( {
			url: localVars.ajax_url,
			type: 'POST',
			data: {
				action: 'blogs_filter',
				nonce: localVars.nonce,
				categoryTerm,
			},
			success( response ) {
				if ( response ) {
					jQuery( '#van-post-container' ).html( response.html );
					jQuery( '.lds-roller' ).hide();
				}
			},
			error() {
				const htmlTag = jQuery( "<h2 class='center-align heading-5'>An error occurred while processing your request.&#x1F614;</h2>" );
				jQuery( '#van-post-container' ).addClass( 'no-post-found' );
				jQuery( '#van-post-container' ).html( htmlTag );
				jQuery( 'body' ).removeClass( 'no-overflow' );
				jQuery( '.lds-roller' ).hide();
			},
		} );
	}
} );

